import React from 'react'
import { Box, BoxProps, Typography } from '@material-ui/core'
import { useStyles } from './styles'
import { useGetOrganization } from 'hooks/useGetOrganization'

const CopyrightText: React.FC<BoxProps> = (props) => {
  const classes = useStyles()
  const { organization } = useGetOrganization()
  const name = organization?.whiteLabel ? organization?.name : 'EXEC, LLC'

  return (
    <Box {...props}>
      <Typography variant='body2' component='p' className={classes.copyright}>
        &copy; {new Date().getFullYear()} {name}. All rights reserved.
      </Typography>
    </Box>
  )
}

export default CopyrightText
